/**
 * Order Status Screen
 */
import React from 'react';
import Layout from '@/components/Layout';
import OrderStatus from '@/containers/OrderStatus';
import { checkForWrongDomain } from '@/utils/checkForWrongDomain';
import { getSSRStoreData } from '../../utils/ssrPageData';
import { useSetSSRStore, useSSRSelector } from '../../redux';
import { getRequiredCtxProps } from 'src/utils/getRequiredCtxProps';

const OrderStatusPage = (props) => {
  useSetSSRStore(props.ssrStore);
  const storeInfo = useSSRSelector((state) => state.storeReducer.store);
  return (
    <Layout
      store={storeInfo}
      title={`Orders - Now Shop Online`}
      Icon={storeInfo?.store_info?.logo_image}
      metaDescription={
        'Now order online from my whatsapp store & pay using 150+ UPI Apps'
      }
      OGImage={storeInfo?.store_info?.logo_image}
      isCustomDomain={props.isCustomDomain}
      {...props}
    >
      <OrderStatus {...props} />
    </Layout>
  );
};

export async function getServerSideProps(ctx) {
  if (checkForWrongDomain(ctx)) return {};
  let propData = {
    catalogCategories: [],
    catalogTags: [],
    collections: [],
  };

  const propType = await getSSRStoreData(ctx, {
    additionalDataToFetch: ['collections', 'categories'],
  });
  const extraProps = getRequiredCtxProps(ctx, propType);

  propData = { ...propData, ...propType };

  return { props: { ...propData, ...extraProps } };
}

export default OrderStatusPage;
